import { mapActions } from 'vuex';

const PROCESSING_TRANSACTION_TIMEOUT = 20;

export default {
  data() {
    return {
      timeout: null,
      showTimeout: false,
    };
  },
  methods: {
    ...mapActions('wallet', ['getBalance']),
    ...mapActions('popup', ['setCurrentPopup']),
    openDepositHistory() {
      this.getBalance();
      this.setCurrentPopup();
      this.$router.push({ name: 'account-history', query: { tabId: 'deposit-withdrawals' } });
    },
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.showTimeout = true;
    }, PROCESSING_TRANSACTION_TIMEOUT * 1000);
  },
  beforeUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
};
